// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1S7EY","title":"FrontImage_title__3waXD"};